import * as classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { IAppOnlyStore } from 'stores/AllStores';
import { SidebarType } from 'stores/Sidebar';
import { browserHistory } from './../../../App';
import { LeadsSearchFilter } from 'stores/Leads';
import { History } from 'history';
import * as zenscroll from 'zenscroll';

// Styles
const s = require('./Topbar.css');
const crmLogo = require('assets/crm-logo.png');
const iconPerson = require('assets/person icon.svg');
const closeIcon = require('assets/close blue icon.svg');

// Component
@inject('store')
@observer
export class Topbar extends React.Component<IAppOnlyStore, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        const { lead, user } = this.props.store;

        return (
            <div className={s.topbar}>
                <NavLink
                    onClick={this.handleDashboardLinkClick(browserHistory)}
                    to="/sales"
                    exact={true}
                    className={s.logo}
                >
                    <img src={crmLogo} />
                </NavLink>

                <ul className={s.navigation}>
                    <li>
                        <NavLink
                            onClick={this.handleDashboardLinkClick(
                                browserHistory
                            )}
                            to="/sales"
                            exact={true}
                            className={s.navLink}
                            activeClassName={s.navLinkActive}
                        >
                            <strong>Dashboard</strong>
                        </NavLink>
                    </li>
                </ul>

                {lead.openLeadsIds.length > 0 && (
                    <ul className={classNames(s.navigation, s.navigationLeads)}>
                        {lead.openLeads.map(openLead => {
                            return (
                                <li key={`lead-${openLead.databaseId}`}>
                                    <button
                                        key={`lead-${openLead.databaseId}-link`}
                                        onClick={this.handleLeadNavClick}
                                        className={classNames(s.navLink, {
                                            [s.navLinkActive]:
                                                lead.openLeadId ===
                                                openLead.databaseId,
                                        })}
                                        data-href={`/sales/lead/${openLead.databaseId}`}
                                    >
                                        <em>
                                            {openLead.dba ||
                                                openLead.legalBusName}
                                        </em>
                                    </button>

                                    <button
                                        key={`lead-${openLead.databaseId}-close`}
                                        onClick={this.handleLeadNavClose(
                                            openLead.databaseId
                                        )}
                                        className={s.closeLead}
                                    >
                                        <span>Close</span>
                                        <img src={closeIcon} />
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                )}

                <ul className={s.actions}>
                    <li>
                        <button
                            onClick={this.handleOpenSidebar(
                                SidebarType.Profile
                            )}
                        >
                            <strong>{user.name || user.username}</strong>
                            <img src={iconPerson} />
                        </button>
                    </li>
                </ul>
            </div>
        );
    }

    private handleDashboardLinkClick = (history: History<any>) => (
        e: React.MouseEvent<HTMLAnchorElement>
    ) => {
        const { leads, activities } = this.props.store;

        // Close activities reminders center if it's open
        activities.closeActivitiesReminders();

        // If user is on notes search section of sales dashboard, go back to leads search
        if (
            history.location.pathname === '/sales' &&
            leads.leadsSearchFilter === LeadsSearchFilter.Notes
        ) {
            zenscroll.toY(0);

            leads.leadsSearchFilter = LeadsSearchFilter.All;
            leads.leadsSearch = '';
            leads.leadsFilterByActivityDate = null;
            leads.leadsFilterByActivityTypeId = null;
        }
    };

    private handleOpenSidebar = (type: SidebarType) => (
        e: React.MouseEvent<HTMLButtonElement>
    ) => {
        e.preventDefault();
        this.props.store.activities.closeActivitiesReminders();
        this.props.store.sidebar.openSidebar(type);
    };

    private handleLeadNavClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.props.store.activities.closeActivitiesReminders();
        const href = e.currentTarget.getAttribute('data-href');
        if (href) {
            browserHistory.push(href);
        }
    };

    private handleLeadNavClose = (id: number) => (
        e: React.MouseEvent<HTMLButtonElement>
    ) => {
        e.preventDefault();
        this.props.store.lead.handleLeadClose(id);
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Topbar/Topbar.tsx